import TabCheckbox from "./form/TabCheckbox";
import DateRangePicker from "./form/DateRangePicker";
import { useMapSearchStore } from "store/useMapSearchStore";

interface SearchFilterBoxProps {
    status: string[];
    allStatus: boolean;
    handleAllStatusCheck: (checked: boolean) => void;
    handleStatusCheck: (e: React.ChangeEvent<HTMLInputElement>) => void;
    selectedStatus: string[];
    startDate: Date | null;
    endDate: Date | null;
    setStartDate: (value: Date | null) => void;
    setEndDate: (value: Date | null) => void;
    handleSubmit: () => void;
}

const SearchFilterBox = ({
    status,
    allStatus,
    handleAllStatusCheck,
    handleStatusCheck,
    selectedStatus,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    handleSubmit,
}: SearchFilterBoxProps) => {
    const { setRefreshFilter } = useMapSearchStore();
    const lineStyle =
        "pr-[41px] relative after:absolute after:content-[''] after:w-[1px] after:h-[24px] after:bg-[#E1E2E4] after:top-1/2 after:right-[20px] after:-translate-y-1/2";

    return (
        <>
            <ul className="flex items-center border-t border-b border-[#E1E2E4] p-[8px_16px]">
                <li className={lineStyle}>
                    <ul className="flex items-center gap-x-[4px]">
                        <li>
                            <TabCheckbox
                                handleChange={e => {
                                    handleAllStatusCheck(e.currentTarget.checked);
                                }}
                                checked={allStatus}
                                id={`check_all_status`}
                                txt={`전체`}
                                value=""
                            />
                        </li>
                        {status.map((txt, i) => {
                            const idx = i + 1;
                            const val = idx.toString();
                            return (
                                <li key={`status_${i}`}>
                                    <TabCheckbox
                                        handleChange={e => {
                                            handleStatusCheck(e);
                                        }}
                                        checked={selectedStatus.includes(val) ? true : false}
                                        id={`check_status${i}`}
                                        txt={txt}
                                        value={val}
                                    />
                                </li>
                            );
                        })}
                    </ul>
                </li>
                <li className={`flex items-center gap-x-[8px]`}>
                    <DateRangePicker
                        startDate={startDate}
                        endDate={endDate}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                        className="w-[360px]"
                    />
                </li>
                <li className={`pl-5 ${lineStyle}`}>
                    <button
                        type="button"
                        className="text-white text-[14px] font-[500] bg-[#FF7B2E] rounded-[5px] px-4 h-[34px]"
                        onClick={handleSubmit}
                    >
                        검색
                    </button>
                </li>
                <li>
                    <button
                        type="button"
                        className="text-[#C2C4C8] text-[14px] font-[500] underline"
                        onClick={() => setRefreshFilter(true)}
                    >
                        검색 초기화
                    </button>
                </li>
            </ul>
        </>
    );
};

export default SearchFilterBox;
